import { loaderAction, setMasterScheduleTimesFormAction } from "../rootReducer";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { api } from "../../helpers/api";
import { MASTER_SCHEDULE_FORM_INITIAL, MASTER_SCHEDULE_TIMES_FORM_INITIAL } from "../initialStateConstant";
import { GetScheduleThunk } from "./GetScheduleThunk";

export const UpdateScheduleThunk = (args) => async (dispatch, getState) => {
    const { user, currentEstablishment } = getState();

    dispatch(loaderAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('master_id', args.master_id || 0);
        formData.append('date', args.date || '');
        formData.append('establishment', currentEstablishment);
        formData.append('times', args.times);

        const response = await api({ data: formData, link: 'update_schedule' });

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Закрываем форму редактирования времени работы мастера
            dispatch(setMasterScheduleTimesFormAction(MASTER_SCHEDULE_TIMES_FORM_INITIAL));

            // Запрашиваем расписание мастера на текущий месяц
            dispatch(GetScheduleThunk({
                master_id: args.master_id,
                date: args.data
            }));

            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
    }
    finally {
        dispatch(loaderAction(false));
    }
};